import { render, staticRenderFns } from "./PixPayment.vue?vue&type=template&id=05bdaeab"
import script from "./PixPayment.vue?vue&type=script&lang=js"
export * from "./PixPayment.vue?vue&type=script&lang=js"
import style0 from "./PixPayment.vue?vue&type=style&index=0&id=05bdaeab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports